<template>
    <div>
        <div class="w9">
            <div class="oheader">
                <a href="/" title="夜樱情趣" class="left">
                    <img src="../../assets/image/logo.png">
                </a>
                <!-- <a href="javascript:;" onclick="jieshou()" class="xhb right"><em class="f pr5 f14"></em>联系客服</a> -->
                <a href="/" class="xhb right mr10">继续购物</a>
                <div class="clear"></div>
            </div>
        </div>
        <div class="w9" id="content">
            <div id="yanOk" class="mb30">
                <div class="okbox pay_12">
                    <p><img src="https://inexweb.oss-cn-shenzhen.aliyuncs.com/szpgbb/resource/image/banner/201906/56dc2b0e49d93fea9313881e13a7eaab.png" class="ico1"></p>
                    <p class="h3" id="repd">等待支付</p>
                    <p class="h1"><b class="f12">¥</b>138</p>
                    <p class="h2">订单提交成功,请用余额密码支付</p>
                    <div id="paydiv" class="pd15 ov" style="font-size:20px;background:#e9e9e9;color: #969696;display: inline-block;border-radius:30px;padding:20px">
                        支付剩余时间：
                        <downtime :day="time" :hour="hour" :minute="minute" style="display: inline-block;" :second="second" :show-colon="false" time="days" backgroundColor="none" splitorColor="#969696" color="#969696" @timeup="timeup"></downtime>
                    </div>
                    <div id="paydiv" class="pd15 ov" style="margin-top:20px;">
                        <span style="font-size:16px;">请输入支付密码：</span>
                        <input type="password" v-model="password" value="" placeholder="请输入支付密码" id="address" class="ip_t w350" size="80">
                    </div>
                    <div id="has_payid" class="mb10 hid">
                        <a href="javascript:checkPay(1);" class="car_btn" style="background-color:#d61212;box-shadow:0px 2px 6px #e86565;">已支付?点击这里查看支付结果</a>
                    </div>
                    <p class="lh20">&nbsp;</p>
                </div>
            </div>
            <div class="od_boxs">
                <h2 class="oh1 alC">订单详情</h2>
                <ul class="hli">
                    <li>
                        <a href="http://qu.dddxi.com/goods-18356.html" target="_blank">欢色 羽田爱1：1真人复刻名器 【五件套】名器+体验升级礼包</a>
                        <em>¥138.00</em>x1
                    </li>
                </ul>
                <div class="fB c3 pt10">
                    <p>订单号：2022020906240141935</p>
                    <p>总金额：<b class="red f16">¥138</b></p>
                </div>
                <a href="user_order.php?act=detail&amp;order_id=17710602" class="gg_fbtn"> <em class="f f14"></em> 查看更多信息</a>
            </div>
        </div>
    </div>
</template>

<script>
import Downtime from './downtime.vue'
export default {
    components:{
        "downtime" : Downtime
    },
    data(){
        return{
            password:"",
            currentTime: 0,
            startTime: 0,
            endTime: 0,
            time: 0,
            hour: 0,
            minute: 0,
            second: 0,
        }
    },
    methods:{
        timeup () {
            this.getPayInfo();
        },
        getPayInfo () {
            var params = {};
            params.id = this.$route.query.id || "";
            this.get_paytype().then(res => {
                params.pay_type = res;
                this.$api.getOrder.getPayOrder(params).then(res => {
                if (res.code == 200) {
                    this.info = res.result;
                    var date = res.result.time;
                    if (this.info.pay.length > 0) {
                        this.pay_id = this.info.pay[0].id;
                        this.pay_needpass = this.info.pay[0].supplier_need_secret;
                    }
                    this.time = parseInt(date / 3600 / 24);
                    this.hour = parseInt(date / 3600) - 24;
                    this.time = Math.floor(date / (60 * 60 * 24));
                    this.hour = Math.floor((date - this.time * 24 * 60 * 60) / 3600);
                    this.minute = Math.floor((date - this.time * 24 * 60 * 60 - this.hour * 3600) / 60);
                    this.second = Math.floor(date - this.time * 24 * 60 * 60 - this.hour * 3600 - this.minute * 60);
                }
                });
            });
        },
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
@import url('../../assets/css/car.css');
.ip_t {
    border: 1px solid #eee;
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    border-radius: 4px;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/car/money.vue